import { MAX_INPUT_LENGTH, MIN_INPUT_LENGTH } from "@finway-group/shared/lib/utils/validators"
import { Rule } from "antd/lib/form"

import { stringRules } from "Components/forms/rules/common/string.rules"
import { generalRules } from "Components/forms/rules/common/general.rules"

export const createUserCommonRules = () => ({
    location: [
        // keep line breaks
        generalRules.required,
        stringRules.noExcessWhitespace,
        stringRules.minLength(MIN_INPUT_LENGTH),
        stringRules.maxLength(MAX_INPUT_LENGTH),
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    position: [
        // keep line breaks
        generalRules.required,
        stringRules.noExcessWhitespace,
        stringRules.minLength(MIN_INPUT_LENGTH),
        stringRules.maxLength(MAX_INPUT_LENGTH),
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
})
